import { Instagram, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { CONTACT } from "../data/content";

/**
 * Instagram-styled grid. Cards are decorative and all link to the real
 * profile — a genuinely live grid of latest posts requires the Instagram
 * Basic Display / Graph API + access token, which Blaine will wire in later.
 */
const TILES = [
  { label: "Match Day", icon: "⚡" },
  { label: "Elite Batch", icon: "👑" },
  { label: "Ball Mastery", icon: "🎯" },
  { label: "Team Talk", icon: "🎙" },
  { label: "Behind the Scenes", icon: "🎬" },
  { label: "Session Highlights", icon: "🔥" },
];

export const InstagramFeed = () => (
  <section id="instagram" className="py-24 sm:py-32 scroll-mt-16 bg-[#050505]" data-testid="instagram-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Overline>Follow the Club</Overline>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-3">
              Life at <span className="text-[#D4AF37]">Zavi FC.</span>
            </h2>
            <p className="text-white/60 text-sm mt-3">Match days, training moments and the Zavi standard — daily on Instagram.</p>
          </div>
          <a href={CONTACT.instagram} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-xs px-5 py-3 hover:bg-[#F3D059] transition-colors duration-200"
            data-testid="ig-follow-top">
            <Instagram size={14} /> @{CONTACT.instagramHandle}
          </a>
        </div>
      </Reveal>

      <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-3">
        {TILES.map((t, i) => (
          <Reveal key={t.label} delay={i * 0.04}>
            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" data-testid={`ig-tile-${i}`}
              className="group relative aspect-square block overflow-hidden border border-white/10 bg-gradient-to-br from-[#0A0A0A] to-black hover:border-[#D4AF37]/40 transition-colors duration-300">
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-4xl sm:text-5xl opacity-60 group-hover:scale-110 transition-transform duration-500" aria-hidden="true">{t.icon}</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3 flex items-center justify-between">
                <p className="text-[10px] uppercase tracking-widest text-white/80 font-bold">{t.label}</p>
                <Instagram size={12} className="text-[#D4AF37]" />
              </div>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 bg-black/40 flex items-center justify-center transition-opacity duration-300">
                <ArrowUpRight size={24} className="text-[#D4AF37]" />
              </div>
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3}>
        <div className="mt-10 text-center">
          <a href={CONTACT.instagram} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 border border-white/20 text-white/80 font-bold uppercase tracking-widest text-xs px-5 py-3 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-200"
            data-testid="ig-follow-bottom">
            <Instagram size={14} /> Follow on Instagram <ArrowUpRight size={13} />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
